import { useLoggerStore } from "./logger-store"

type LogLevel = "info" | "warn" | "error" | "debug"

class Logger {
  private static instance: Logger

  private constructor() {}

  static getInstance(): Logger {
    if (!Logger.instance) {
      Logger.instance = new Logger()
    }
    return Logger.instance
  }

  private log(level: LogLevel, source: string, message: string, data?: unknown) {
    const store = useLoggerStore.getState()
    store.addLog({ level, source, message, data })

    // Also log to console for development
    const consoleMethod = level === "error" ? "error" : level === "warn" ? "warn" : "log"
    console[consoleMethod as "log" | "warn" | "error"](`[${source}] ${message}`, data ? data : "")
  }

  info(source: string, message: string, data?: unknown) {
    this.log("info", source, message, data)
  }

  warn(source: string, message: string, data?: unknown) {
    this.log("warn", source, message, data)
  }

  error(source: string, message: string, data?: unknown) {
    this.log("error", source, message, data)
  }

  debug(source: string, message: string, data?: unknown) {
    this.log("debug", source, message, data)
  }

  exportLogs(): string {
    return useLoggerStore.getState().exportLogs()
  }

  clearLogs() {
    useLoggerStore.getState().clearLogs()
  }

  getLogs() {
    return useLoggerStore.getState().getLogs()
  }
}

export const logger = Logger.getInstance()
